<script>
import MainButton from "@/components/Common/Buttons/MainButton.vue";
import UniHospitalLogo from "@/components/Common/Icons/UniHospitalLogo.vue";
import HamburgerMenuIcon from "@/components/Common/Icons/HamburgerMenuIcon.vue";
import CloseIconX from "@/components/Common/Icons/CloseIconX.vue";
import PhoneIcon from "@/components/Common/Icons/PhoneIcon.vue";
import ClockIcon from "@/components/Common/Icons/ClockIcon.vue";
import LanguageButton from "@/components/Common/Buttons/LanguageButton.vue";
import SubmenuItem from "@/components/Components/HeaderDesktop/SubmenuItem.vue";
import FullHeightSideBar from "@/components/Common/FullHeightSideBar.vue";

export default {
  components: {
    SubmenuItem,
    MainButton,
    UniHospitalLogo,
    HamburgerMenuIcon,
    ClockIcon,
    CloseIconX,
    PhoneIcon,
    FullHeightSideBar,
    LanguageButton
  },
  props: {
    theme: {
      type: String
    }
  },
  data() {
    return {
      showSubmenu: false,
      offices: []
    };
  },
  computed: {
    isMenuVisible() {
      return this.$store.state.utils.isOfficesModalOpen;
    }
  },
  methods: {
    async showMenu() {
      await this.$store.dispatch("utils/toggleOfficesModal", true);
    },
    async hideMenu() {
      await this.$store.dispatch("utils/toggleOfficesModal", false);
    },
    async handleSidebarClose() {
      await this.$store.dispatch("utils/toggleOfficesModal", false);
    },
    async handleHideSubMenu() {
      this.showSubmenu = false;
    },
    async handleMobileMenuClose() {
      await this.$store.dispatch("utils/toggleOfficesModal", false);
      await this.handleHideSubMenu();
    }
  },
  async mounted() {
    const response = await this.$store.dispatch("offices/getOffices");
    this.offices = response.data
  },
};
</script>

<template>
  <nav v-bind:class="{
    'header-mobile-wrapper': true,
    'background-header-home': theme === 'home-page'}">
    <div class="nav-container d-flex d-md-grid ">
      <div class="nav-left">
        <router-link :to="{name: 'home'  }">
          <UniHospitalLogo/>
        </router-link>
      </div>
      <div class="menu-navigation d-none d-md-flex">
        <div class="navigation-item d-flex" @click="showMenu">
          <div class="d-flex align-self-center icon ">
            <HamburgerMenuIcon/>
          </div>
          <div>{{ $t('offices') }}</div>
        </div>
        <router-link :to="{name: 'TeamView'  }">
          <div class="navigation-item"> {{ $t('team') }}</div>
        </router-link>
        <router-link :to="{name: 'VenousCenterView'  }">
          <div class="navigation-item"> {{ $t('venous-center') }}</div>
        </router-link>
        <router-link v-if="false" :to="{name: 'ServicesView'} ">
          <div class="navigation-item"> {{ $t('services') }}</div>
        </router-link>
        <router-link :to="{name: 'AboutUsView'} ">
          <div class="navigation-item"> {{ $t('about-us') }}</div>
        </router-link>
        <router-link :to="{name: 'NewsView'} ">
          <div class="navigation-item"> {{ $t('news') }}</div>
        </router-link>
        <router-link :to="{name: 'ContactsView'} ">
          <div class="navigation-item"> {{ $t('contacts') }}</div>
        </router-link>
      </div>
      <div class="nav-right d-none d-md-flex">
        <div class="header-contact-info me-3">
          <a class="d-flex justify-content-end phone-icon" href="tel:+359884 64 87 11">
            <PhoneIcon/>
            <div class="ms-1">0884 64 87 11</div>
          </a>
          <div class="d-flex justify-content-end clock-icon">
            <ClockIcon/>
            <div class="ms-1">{{ $t('working-days') }}: {{ $t('working-hours') }}</div>
          </div>
        </div>
        <div class=" button-appointment">
          <a :href="$router.resolve({name: 'BookAppointmentView'}).href">
            <MainButton :buttonText="$t('book-appointment-online')" :icon="'calendar'" :size="'small'"
                        :theme="'solid-blue'"/>
          </a>
        </div>
        <div v-if="false">
          <LanguageButton/>
        </div>
      </div>
      <div class="d-md-none ms-auto d-flex">
        <div class=" me-3">
          <a :href="$router.resolve({name: 'BookAppointmentView'}).href">
            <MainButton :buttonText="$t('book-appointment')" :size="'small'" :theme="'solid-blue'"/>
          </a>
        </div>
        <div class="d-flex align-self-center icon" @click="showMenu">
          <HamburgerMenuIcon/>
        </div>
      </div>
    </div>
  </nav>

  <FullHeightSideBar v-if="isMenuVisible" class="offices-sidebar" @onClose="handleSidebarClose">
    <div class="submenu-wrapper">
      <div v-for="(title, index) in offices" :key="index" class="submenu-items">
        <router-link :to="{name: 'OneOfficeView', params: { id: title.id } }">
          <SubmenuItem :title="title.content.title"/>
        </router-link>
      </div>
    </div>
  </FullHeightSideBar>

  <div v-if="isMenuVisible" class="menu-mobile-wrapper d-md-none">
    <div class="menu-header">
      <div class="d-flex align-items-center">
        <div v-if="!showSubmenu">
          <router-link :to="{name: 'home'} ">
            <UniHospitalLogo/>
          </router-link>
        </div>
        <div class="ms-auto icon" @click="hideMenu">
          <CloseIconX/>
        </div>
      </div>
      <div v-if="!showSubmenu" class="d-flex mt-4">
        <div>
          <a class="d-flex align-items-center" href="tel:+359884 64 87 11">
            <PhoneIcon/>
            <div class="ms-1">0884 64 87 11</div>
          </a>
          <div class="d-flex align-items-center">
            <ClockIcon/>
            <div class="ms-1">{{ $t('working-days') }}: {{ $t('working-hours') }}</div>
          </div>
        </div>
        <div v-if="false" class="ms-auto">
          <LanguageButton/>
        </div>
      </div>
    </div>
    <div v-if="!showSubmenu" class="menu-navigation">
      <div class="navigation-item" @click="showSubmenu = true"> {{ $t('offices') }}</div>
      <router-link :to="{name: 'TeamView'  }">
        <div class="navigation-item"> {{ $t('team') }}</div>
      </router-link>
      <router-link :to="{name: 'VenousCenterView'  }">
        <div class="navigation-item"> {{ $t('venous-center') }}</div>
      </router-link>
      <router-link v-if="false" :to="{name: 'ServicesView'} ">
        <div class="navigation-item"> {{ $t('services') }}</div>
      </router-link>
      <router-link :to="{name: 'AboutUsView'} ">
        <div class="navigation-item"> {{ $t('about-us') }}</div>
      </router-link>
      <router-link :to="{name: 'NewsView'} ">
        <div class="navigation-item"> {{ $t('news') }}</div>
      </router-link>
      <router-link :to="{name: 'ContactsView'} ">
        <div class="navigation-item"> {{ $t('contacts') }}</div>
      </router-link>
    </div>
    <FullHeightSideBar v-if="showSubmenu"
                       :show-back-btn="true"
                       class="offices-sidebar"
                       @onBack="handleHideSubMenu"
                       @onClose="handleMobileMenuClose">
      <div class="submenu-wrapper">
        <div v-for="(title, index) in offices" :key="index" class="submenu-items">
          <router-link :to="{name: 'OneOfficeView', params: { id: title.id } }">
            <SubmenuItem :title="title.content.title"/>
          </router-link>
        </div>
      </div>
    </FullHeightSideBar>
  </div>
</template>

<style lang="scss" scoped>
.offices-sidebar {
  background: $color-light-brown;
}

.header-mobile-wrapper {
  background: rgba(241, 231, 225, 0.7);
  width: 100%;
  border-radius: 30px;
  padding: 5px 20px;

  .navigation-item {
    font-size: 14px;
    font-family: $font-bold;
    margin: 0px 10px;
    cursor: pointer;
    color: $color-brown;

    &:hover {
      color: $color-blue-accent;
    }

    .icon {
      transform: scale(0.5);
    }
  }


  .header-contact-info {
    font-size: 11px;
    text-align: right;
    min-width: 180px;

    .phone-icon {
      svg {
        margin-top: 5px;
      }
    }

    .clock-icon {
      svg {
        margin-top: 3px !important;
      }
    }
  }

  .nav-container {
    display: grid;
    grid-template-columns: 1fr auto 1fr; /* Three columns, middle is auto-sized */
    align-items: center; /* Center items vertically */
    width: 100%; /* Full width */
  }

  /* Center the menu-navigation */
  .menu-navigation {
    display: flex;
    justify-content: center; /* Center items horizontally */

  }

  /* Ensure the left and right sections are positioned correctly */
  .nav-left, .nav-right {
    display: flex;
    align-items: center;
  }

  .nav-right {
    justify-content: flex-end; /* Align items to the right */
  }

}

.background-header-home {
  background: rgba(255, 255, 255, 0.8);
}

.menu-mobile-wrapper {
  background: $color-light-brown;
  position: fixed;
  top: 0;
  left: 0;
  height: 100vh;
  width: 100%;
  color: $color-dark-brown;

  .menu-header {
    border-bottom: 1px solid gray;
    padding: 25px;
  }

  .navigation-item {
    font-size: 26px;
    font-family: $font-bold;
    margin: 20px 0;
    padding: 0 20px;
    cursor: pointer;
  }
}

.submenu-wrapper {
  padding: 0;

  .submenu-items {
    margin: 10px 0;
  }
}

.icon {
  cursor: pointer;
}

@media screen and (min-width: 768px) {
  .submenu-wrapper {
    margin-top: 20px;
    padding: 0 50px;
  }
  .header-mobile-wrapper {
    .navigation-item {
      font-size: 10px;
    }
  }

}

@media screen and (min-width: 1100px) {
  .header-mobile-wrapper {
    .navigation-item {
      font-size: 14px;
    }
  }

}

</style>